import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import ImageRadio from "../inputs/image-radio";
import { isPullActiveCoach } from "../../utils/user-helpers";

export const EditWidgetInfoModal = ({
  iconsRadios,
  widgetDescription,
  widgetIcon,
  widgetName,
  handleInputChange,
  handleSubmit,
  isOpen,
  onClose,
  validationSubmit,
  WidgetTogglePull,
  WidgetTogglePush,
  userToRequest,
  pullPermission,
  pushPermission,
}) => {
  const { t } = useTranslation(["coaching-portal", "common"]);

  if (!isOpen) {
    return null;
  }
  return (
    <Modal
      className={"edit-widget-modal Widget-Modal"}
      title={t("editWidgetInfo.title")}
      onClose={onClose}
    >
      <div className="body">
        <div>
          <div className="input-group">
            <label>{t("editWidgetInfo.nameLabel")}</label>
            <input
              maxLength="30"
              name="name-mobile"
              className="text-input"
              placeholder={t("editWidgetInfo.namePlaceholder")}
              value={widgetName}
              onChange={handleInputChange}
              sz="large"
            />
          </div>

          <div className="input-group">
            <label>{t("editWidgetInfo.descriptionLabel")}</label>
            <input
              maxLength="60"
              name="description-mobile"
              className="text-input"
              placeholder={t("editWidgetInfo.descriptionPlaceholder")}
              value={widgetDescription}
              onChange={handleInputChange}
              sz="large"
            />
          </div>

          <div className="input-group">
            <ImageRadio
              label={t("editWidgetInfo.iconLabel")}
              name="icon-mobile"
              currentValue={widgetIcon}
              radios={iconsRadios}
              onChange={handleInputChange}
              isManager={true}
            />
          </div>

          <div className="input-group">
            <label>{t("editWidgetInfo.userTypeAccess")}</label>
            {isPullActiveCoach(userToRequest) && (
              <WidgetTogglePull permission={pullPermission} />
            )}
            {userToRequest.pushAccountInfo && (
              <WidgetTogglePush permission={pushPermission} />
            )}
          </div>
        </div>
      </div>

      <footer>
        <button
          data-button-type="secondary"
          data-action="cancel"
          onClick={onClose}
        >
          {t("common:cancel")}
        </button>
        <button
          data-button-type="primary"
          onClick={(e) => {
            handleSubmit(e);
            onClose();
          }}
          disabled={!validationSubmit()}
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};
